import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-size-selector',
  templateUrl: './size-selector.component.html',
  styleUrl: './size-selector.component.scss',
})
export class SizeSelectorComponent {
  @Input() sizes: number[] = [];
  @Input() value = 0;

  @Output() changeSize = new EventEmitter<number>();
}
